import React, { useState, useEffect } from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import SubHeader from '../components/SubHeader'
import CommonTable from '../components/Common_table'
import { useGlobalContext } from '../../context/Context'
import Addcatalogue from '../components/Add_catalogue';
import Viewcatalogue from '../components/View_catalogue';
import Cataloguestatus from '../components/Catalogue_Status'
import CircularProgress from '@mui/material/CircularProgress';
import instance from '../../Utils/api';

const SubCategory = () => {
  const title = { name: "Sub-Category", subheading: "Add to the sub-catalogue and view products", search: "", button: "Add sub-category" }

  const columns = [
    { label: "S.No", field: "sno", },
    { label: "Sub Category", field: "subCategory", },
    { label: "subCategory Image", field: "Bannerimage", },
    { label: "Status", field: "status", },
    { label: "Created Date", field: "createddDate", },
    { label: "Last Updated Date", field: "UpdatedDate", },
    { label: "Actions", field: "action", }
  ];

  const { loading, setLoading } = useGlobalContext();
  const { openDialog, setOpenDialog } = useGlobalContext();
  const { openviewDialog, setopenviewDialog } = useGlobalContext();
  const { statusDialog, setstatusDialog } = useGlobalContext();
  const [edit, setEdit] = useState(false);
  const [subCategory, setsubCategory] = useState([]);
  const [getsubcategory, setgetsubCategory] = useState(false)
  const [selectedsubCategory, setselectedsubCategory] = useState(null)

  //fetch SubCategory
  const fetchsubCategory = async () => {
    try {
      const response = await instance.get('/Catalogue/getSubCategory')
      const formatteddata = response?.data?.data?.map((subcategory, index) => ({
        sno: index + 1,
        category: subcategory?.category,
        subCategory: subcategory?.subCategory,
        category: subcategory?.category,
        Bannerimage: subcategory?.picture,
        status: subcategory?.status,
        createddDate: new Date(subcategory?.createdAt).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
        UpdatedDate: new Date(subcategory?.updatedAt).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
        subcategoryId: subcategory?._id,
      }))

      setsubCategory(formatteddata);
    }
    catch (error) {
      console.log("error to fetch subcategory:", error.message)
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    fetchsubCategory()
    setgetsubCategory(false)
    setLoading(true);
  }, [getsubcategory])

  // Handle Row Click for Edit
  const handleEditClick = (subcategory) => {
    setselectedsubCategory(subcategory); // Set selected category data
    setEdit(true); // Set to edit mode
    setOpenDialog(true);
  };

  // Handle Row Click for view
  const handleViewClick = (subcategory) => {
    setselectedsubCategory(subcategory); // Set selected employee data
    setopenviewDialog(true)
  }
  // Handle Row Click for status change
  const handleStatusClick = (subcategory) => {
    setselectedsubCategory(subcategory);
    setstatusDialog(true); // Show the status popup
  };
  return (
    <>
      <Topbar />
      <section className='admin-catalogue'>
        <PageHeader
          title={title}
          search={'subcategory'}
          files={false}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
        />
        <SubHeader
          menu={false}
          filter={false}
        />
        {loading ?
          <div className='loader-section'>
            <CircularProgress />
          </div>
          :
          <CommonTable
            edit={edit}
            setEdit={setEdit}
            columns={columns}
            rows={subCategory}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            openviewDialog={openviewDialog}
            setopenviewDialog={setopenviewDialog}
            handleEditClick={handleEditClick}
            handleViewClick={handleViewClick}
            handleStatusClick={handleStatusClick}
            banner={true}
            menu={true}
            showPagination={false}
          />
        }
        <Viewcatalogue
          openviewDialog={openviewDialog}
          setopenviewDialog={setopenviewDialog}
          selectedsubCategory={selectedsubCategory}
          mode="subcategory"
          setgetsubCategory={setgetsubCategory}

        />
        <Addcatalogue
          edit={edit}
          setEdit={setEdit}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          selectedsubCategory={selectedsubCategory}
          setgetsubCategory={setgetsubCategory}
          mode="subcategory"
        />
        <Cataloguestatus
          statusDialog={statusDialog}
          setstatusDialog={setstatusDialog}
          selectedsubCategory={selectedsubCategory}
          setgetsubCategory={setgetsubCategory}
          mode="subcategory"
        />
      </section>
    </>
  )
}

export default SubCategory;
